module.exports = "ul {\n  list-style-type: disc;\n  list-style-position: inside;\n}\n\nol {\n  list-style-type: decimal;\n  list-style-position: inside;\n}\n\nul ul, ol ul {\n  list-style-type: circle;\n  list-style-position: inside;\n  margin-left: 15px;\n}\n\nol ol, ul ol {\n  list-style-type: lower-latin;\n  list-style-position: inside;\n  margin-left: 15px;\n}\n\nul.none, ol.none li {\n  list-style-type: none !important;\n}\n\nul.list-unstyled li {\n  list-style-type: none !important;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.css
// module id = ./src/app/components/home/home.css
// module chunks = main